import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { chatApi as r } from "@maat/api-chat";
//#region src/hooks/useUnassignInboxContactMutation.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.unassignInboxContact(i, e),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.inboxAssignees(i) });
		}
	});
};
//#endregion
export { i as useUnassignInboxContactMutation };
